import { createAsyncThunk } from "@reduxjs/toolkit";
import businessUserService from "../../../api/services/businessUser";
import companyService from "../../../api/services/company";
import authService from "../../../api/services/auth";

export const fetchBusinessUserInfo = createAsyncThunk(
  "businessUser/fetch-business-user-info",
  async (requestData) => {
    return await businessUserService.fetchBusinessUserInfo(requestData);
  }
);

export const getInvitationLink = createAsyncThunk(
  "businessUser/get-invitation-link",
  async (requestData) => {
    return await businessUserService.getInvitationLink(requestData);
  }
);

export const editCompanyInfo = createAsyncThunk(
  "company/edit-company-info",
  async (requestData) => {
    return await companyService.editCompanyInfo(requestData);
  }
);

export const editCompanyProfile = createAsyncThunk(
  "company/edit-company-profile",
  async (requestData) => {
    return await companyService.editCompanyProfile(requestData);
  }
);

export const logout = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  thunkAPI.dispatch({ type: "logout" });
  thunkAPI.dispatch({ type: "reset" });
  return await authService.logout();
});

export const getCustomers = createAsyncThunk(
  "company/get-customers",
  async (requestData) => {
    return await businessUserService.getCustomers(requestData);
  }
);

export const createCustomer = createAsyncThunk(
  "company/create-customer",
  async (requestData) => {
    return await businessUserService.createCustomer(requestData);
  }
);

export const adminLoginToBusinessUser = createAsyncThunk(
  "businessUser/admin-login-to-business-user",
  async (businessUserId, thunkAPI) => {
    const payload = await businessUserService.adminLoginToBusinessUser(
      businessUserId
    );
    thunkAPI.dispatch({ type: "logout" });
    thunkAPI.dispatch({ type: "reset" });
    return payload;
  }
);

export const getAllBusinessUserRoles = createAsyncThunk(
  "marketplace/get-all-businessUserRoles",
  async (page) => {
    return await businessUserService.getAllBusinessUserRoles(page);
  }
);

export const addRoleToUser = createAsyncThunk(
  "marketplace/add-role-user",
  async (requestData) => {
    return await businessUserService.addRoleToUser(requestData);
  }
);

export const createBusinessUserRole = createAsyncThunk(
  "marketplace/create-role-user",
  async (requestData) => {
    return await businessUserService.createBusinessUserRole(requestData);
  }
);

export const updateBusinessUserRole = createAsyncThunk(
  "marketplace/update-role-user",
  async (requestData) => {
    return await businessUserService.updateBusinessUserRole(requestData);
  }
);
